import { FormSectionProperties } from './properties/form-section-properties.model';
import { Widget } from './form-widget.model';
import { WidgetBuilder } from './form-widget-builder.model';

export class FormSection {
  public id?: string = 'uid' + Math.random().toString(36).substring(2);
  public name: string;
  public title: string;
  public properties: FormSectionProperties;
  public widgets: Widget[];

  constructor(data: any = {}) {
    // WARNING: title obsolete
    this.id = data.id || this.id;
    this.title = data.title || 'Section';
    this.properties = new FormSectionProperties(data.properties);

    if (data.widgets instanceof Array) {
      const widgets = data.widgets.map((item) => {
        return WidgetBuilder.create(item);
      });
      this.widgets = widgets.filter((item) => item);
    } else {
      this.widgets = [];
    }
  }
}
